import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import EN from 'assets/i18n/en/translation.json';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  // .use({ type: 'backend',
  //   init (services, backend, i18next) { },
  //   read (lang, ns, callback) { },
  //   readMulti (languages, namespaces, callback) { }
  // } as BackendModule)
  .init({
    resources: {
      en: {
        translation: EN,
      },
    },

    // backend: {
    //   path: '/i18n/{{lng}}/{{ns}}.json',
    // },

    lng: 'en', // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

export default i18n;
